import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectDownloadError,
  selectIsDownloadLoading,
  selectIsUploadLoading,
  selectIsUploadSuccess,
  selectUploadError,
  selectUploadSuccessCount,
} from '../selectors/external-buyer-mappings.selectors';

@Injectable({ providedIn: 'root' })
export class ExternalBuyerMappingsSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly isUploadLoading = this._store.selectSignal(
    selectIsUploadLoading,
  );
  public readonly isUploadSuccess = this._store.selectSignal(
    selectIsUploadSuccess,
  );
  public readonly uploadSuccessCount = this._store.selectSignal(
    selectUploadSuccessCount,
  );
  public readonly uploadError = this._store.selectSignal(selectUploadError);
  public readonly isDownloadLoading = this._store.selectSignal(
    selectIsDownloadLoading,
  );
  public readonly downloadError = this._store.selectSignal(selectDownloadError);
}
